"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M7 15v-4.81l4-3.6V15zm6 0V6.59l4 3.6V15z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M19 12h3L12 3 2 12h3v3H3v2h2v3h2v-3h4v3h2v-3h4v3h2v-3h2v-2h-2zM7 15v-4.81l4-3.6V15zm6 0V6.59l4 3.6V15z"
}, "1")], 'FoundationTwoTone');